import posthog from 'posthog-js';

export default function posthogAnalyticsPlugin(userConfig) {
  return {
    name: 'posthog-analytics-plugin',

    config: {
      apiKey: userConfig.apiKey,
    },

    initialize: ({ config }) => {
      if (globalThis.__TEST__) {
        return;
      }

      const { apiKey } = config;

      // don't enable if ember-metrics is explicitly disabled
      const metaTag = document.querySelector('meta[name="disable-metrics"]');
      if (metaTag) {
        return;
      }

      posthog.init(apiKey, {
        api_host: 'https://us.i.posthog.com',
        defaults: '2025-11-30',
      });

      posthog.register({
        source: 'eternal-sledgehammer',
        environment: pnEnv.RAILS_ENV,
      });
    },

    /* eslint-disable-next-line no-unused-vars */
    page: ({ payload }) => {
      // PostHog automatically tracks page views
    },

    track: ({ payload }) => {
      const { event, properties } = payload;
      posthog.capture(event, properties);
    },

    identify: ({ payload }) => {
      try {
        let {
          traits,
          traits: { email },
        } = payload;

        if (!email) {
          return;
        }

        email = email.toLowerCase();
        posthog.identify(email, traits);
      } catch (error) {
        posthog.captureException(error);
      }
    },

    loaded: () => {
      return !!posthog;
    },
  };
}
